import { createContext, useContext } from 'react';

const ThemeContext = createContext({
  themeMode: 'light',
  isDark: false,
  toggleTheme: () => {},
  restoreTheme: () => {},
  setThemeMode: () => {},
});

export const useThemeMode = () => useContext(ThemeContext);

export default ThemeContext;
